import { ISpawnPoint } from '../interfaces/ISpawnPoint';
import { VehicleSpawnPoint } from './VehicleSpawnPoint';
import { CharacterSpawnPoint } from './CharacterSpawnPoint';
import { World } from './World';
import { LoadingManager } from '../core/LoadingManager';
import { Driver } from '../enums/driver';

export class Scenario {
    public id: string;
    public name: string;
    public spawnAlways = false;
    public default = false;
    public world: World;
    private rootNode: THREE.Object3D;
    private spawnPoints: ISpawnPoint[] = [];
    private invisible = false;
    private initialCameraAngle: number;

    constructor(root: THREE.Object3D, world: World) {
        this.rootNode = root;
        this.world = world;
        this.id = root.name;

        // Scenario
        if (root.userData.hasOwnProperty('name')) {
            this.name = root.userData.name;
        }
        if (root.userData.hasOwnProperty('default') && root.userData.default === 'true') {
            this.default = true;
        }
        if (root.userData.hasOwnProperty('spawn_always') && root.userData.spawn_always === 'true') {
            this.spawnAlways = true;
        }
        if (root.userData.hasOwnProperty('invisible') && root.userData.invisible === 'true') {
            this.invisible = true;
        }
        if (root.userData.hasOwnProperty('camera_angle')) {
            this.initialCameraAngle = root.userData.camera_angle;
        }

        if (!this.invisible) this.createLaunchLink();

        // Find all scenario spawns and entities
        root.traverse((child) => {
            if (child.hasOwnProperty('userData') && child.userData.hasOwnProperty('data')) {
                if (child.userData.data === 'spawn') {
                    if (child.userData.type === 'car' || child.userData.type === 'airplane' || child.userData.type === 'heli') {
                        let sp = new VehicleSpawnPoint(child);

                        if (child.userData.hasOwnProperty('type')) {
                            sp.type = child.userData.type;
                        }

                        if (child.userData.hasOwnProperty('driver')) {
                            sp.driver = child.userData.driver;

                            if (child.userData.driver === Driver.AI && child.userData.hasOwnProperty('first_node')) {
                                sp.firstAINode = child.userData.first_node;
                            }
                        }

                        this.spawnPoints.push(sp);
                    } else if (child.userData.type === 'player') {
                        let sp = new CharacterSpawnPoint(child, this.world.playerService);
                        this.spawnPoints.push(sp);
                    }
                }
            }
        });
    }

    public createLaunchLink(): void {
        this.world.params[this.name] = () => {
            this.world.launchScenario(this.id);
        };
    }

    public launch(loadingManager: LoadingManager, world: World): void {
        this.spawnPoints.forEach((sp) => {
            sp.spawn(loadingManager, world);
        });

        if (!this.spawnAlways) {
            if (loadingManager.onFinishedCallback === undefined) {
                loadingManager.onFinishedCallback = () => {
                    world.update(1, 1);
                    world.setTimeScale(1);
                };
            }
            world.cameraOperator.theta = this.initialCameraAngle;
            world.cameraOperator.phi = 15;
        }
    }
}
